module.exports = __webpack_public_path__ + "08_bob_beige.afd82617.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/08_bob_beige.png
// module id = VT77
// module chunks = 0